import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-legal-writing',
  templateUrl: './legal-writing.component.html',
  styleUrls: ['./legal-writing.component.scss']
})
export class LegalWritingComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public navigationService: NavigationService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('法律文件校對與編修工具｜專為律師打造的 AI 法律檢查助手');
    this.metaTagService.updateTag({ name: 'description', content: "使用 Trinka 全方位法律校對與編修工具，提升您的法律文件品質。Trinka 的法律文法檢查功能可精準檢查法律專業用語，確保語句正確且符合合規需求。專為法律專業人士設計，從術語、語法到表達清晰度，逐一細緻校對，讓您的法律文件更專業、更可信。" });
    this.metaTagService.updateTag({ property: 'og:title', content: '法律文件校對與編修工具｜專為律師打造的 AI 法律檢查助手' });
    this.metaTagService.updateTag({ property: 'og:description', content: "使用 Trinka 全方位法律校對與編修工具，提升您的法律文件品質。Trinka 的法律文法檢查功能可精準檢查法律專業用語，確保語句正確且符合合規需求。專為法律專業人士設計，從術語、語法到表達清晰度，逐一細緻校對，讓您的法律文件更專業、更可信。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/features/legal-writing' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/legal-writing/legal-writing-banner.png' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '法律文件校對與編修工具｜專為律師打造的 AI 法律檢查助手' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "使用 Trinka 全方位法律校對與編修工具，提升您的法律文件品質。Trinka 的法律文法檢查功能可精準檢查法律專業用語，確保語句正確且符合合規需求。專為法律專業人士設計，從術語、語法到表達清晰度，逐一細緻校對，讓您的法律文件更專業、更可信。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/legal-writing/legal-writing-banner.png' });
    this.metaTagService.updateTag({ name: 'keywords', content: 'legal checking, legal proofreading, law proofreading, proofreading in law, ai tools for lawyers, legal transcript proofreader, proofread legal documents, legal grammar checker, legal proofreading software, legal editing and proofreading, legal proof reader, legal writing tool, legal writing grammar checker, tool for lawyers, legal proofreading services' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/features/legal-writing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/legal-writing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/legal-writing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/legal-writing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/legal-writing' });
  }

}
